import React from "react";
import { ExclamationIcon } from "@heroicons/react/solid";
import { classNames } from "../../Utils";

const WarningNote = ({
  message = "",
  className = "",
  iconClassName = "",
  textClassName = "",
}) => {
  return (
    <div
      className={classNames(
        "inline-flex items-start gap-2 self-start rounded-lg border border-yellow-200 bg-yellow-50 px-3 py-2",
        className
      )}
    >
      <ExclamationIcon
        className={classNames("h-5 w-5 text-yellow-500", iconClassName)}
      />
      <span className={classNames("text-xs text-yellow-800", textClassName)}>
        {message}
      </span>
    </div>
  );
};

export default WarningNote;
